import {Injectable} from '@angular/core';
import {GroupConfig, GroupConfigs} from '../models/config';
import { LoadMyCompaniesLinkContractAction } from '../actions/companies-link-contract';

// @ts-ignore
@Injectable({
  providedIn: 'root'
})
export class GetConfigSharedService {

  constructor() {
  }
  getContractSiteFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigContractFilter()
      ]
    }
  }
  getConfigContractFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_START_DATE',
          controlName: ['startDate'],
          placeholder: 'GENERIC_START_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_PRICE',
          controlName: ['price'],
          placeholder: 'GENERIC_PRICE',
          presentation: 'filter',
          options: {
            show: true,
            inputType: {
              type: 'number',
              step: 0.1
            }
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_END_DATE',
          controlName: ['endDate'],
          placeholder: 'GENERIC_END_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        // {
        //   type: 'input',
        //   label: 'CONTRACT_PURCHASE_ORDER',
        //   controlName: ['po'],
        //   placeholder: 'CONTRACT_PURCHASE_ORDER',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // }
      ]
    }
  }
  getConfigSharedAddressReadOnly(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_1',
          controlName: ['line1'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_1',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_2',
          controlName: ['line2'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_2',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_3',
          controlName: ['line3'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_3',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_ZIP',
          controlName: ['zip'],
          placeholder: 'ORDER_FORM_ADDRESS_ZIP',
          presentation: 'detail',
          options: {
            show: true,
            shortInput: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_CITY',
          controlName: ['city'],
          placeholder: 'ORDER_FORM_ADDRESS_CITY',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_STATE',
          controlName: ['state'],
          placeholder: 'ORDER_FORM_ADDRESS_STATE',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_ADDRESS_COUNTRY',
          controlName: ['countryForm', 'name'],
          placeholder: 'ORDER_FORM_ADDRESS_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'detail'
        },
      ]
    }
  };

  getConfigSharedContactReadOnly(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_NAME',
          controlName: ['name'],
          placeholder: 'ORDER_FORM_CONTACT_NAME',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_SURNAME',
          controlName: ['surname'],
          placeholder: 'ORDER_FORM_CONTACT_SURNAME',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_PHONE',
          controlName: ['phone'],
          placeholder: 'ORDER_FORM_CONTACT_PHONE',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_MOBILE',
          controlName: ['mobile'],
          placeholder: 'ORDER_FORM_CONTACT_MOBILE',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_EMAIL',
          controlName: ['email'],
          placeholder: 'ORDER_FORM_CONTACT_EMAIL',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_DEPARTMENT',
          controlName: ['department'],
          placeholder: 'ORDER_FORM_CONTACT_DEPARTMENT',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: false
          }
        },
      ]
    }
  };
  getInvoicesManagement(): GroupConfig {
    return {
      'config': [
        {
          type: 'checkBox',
          label: 'INVOICES_MANAGEMENT_CLEAR_INVOICES_CHECKBOX_MODAL',
          controlName: ['clearInvoices'],
          placeholder: 'INVOICES_MANAGEMENT_CLEAR_INVOICES_CHECKBOX_MODAL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            labelPosition: 'right',
            inputOptions: false,
          }
        },
        {
          type: 'checkBox',
          label: 'INVOICES_MANAGEMENT_USE_PERIODIC_CHECKBOX_MODAL',
          controlName: ['usePeriodic'],
          placeholder: 'INVOICES_MANAGEMENT_USE_PERIODIC_CHECKBOX_MODAL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            labelPosition: 'right',
            inputOptions: false,
          }
        },
      ]
    }
  };
  getLinkContract(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'CONTRACT_LINK_MODAL_BILLING_START',
          controlName: ['startBilling'],
          placeholder: 'CONTRACT_LINK_MODAL_BILLING_START',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              daysOfWeekDisable: false,
              useCurrent: false,
              defaultDate: null
            }
          },
        },
        {
          type: 'datePicker',
          label: 'CONTRACT_LINK_MODAL_BILLING_END',
          controlName: ['endBilling'],
          placeholder: 'CONTRACT_LINK_MODAL_BILLING_END',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              daysOfWeekDisable: false,
              useCurrent: false,
              defaultDate: null,
              checkboxEndlessMode: true,
              checkboxEndlessModeCheck: false,
              checkboxEndlessModeText: 'DATE_PICKER_CHECKBOX_OPTIONS',

            }
          },
        },
        {
          type: 'typeAhead',
          label: 'CONTRACT_LINK_MODAL_COMPANY',
          controlName: ['companyName', 'companyUuid'],
          placeholder: 'CONTRACT_LINK_MODAL_COMPANY_PLACEHOLDER',
          data: 'companyList',
          options: {
            show: true,
            value: 'companyUuid',
            vue: 'companyName',
            labelShowInDetail: false,
            checkboxEndlessMode: true,
            checkboxEndlessModeCheck: true,
            checkboxEndlessModeText: 'KEEP_THE_ACTUAL_LINKED_COMPANY_CHECKBOX_OPTIONS',
          },
          presentation: 'edit'
        },
        {
          type: 'typeAhead',
          label: 'CONTRACT_LINK_MODAL_CONTRACT',
          controlName: ['contractName', 'contractUuid'],
          placeholder: 'CONTRACT_LINK_MODAL_CONTRACT_PLACEHOLDER',
          data: 'contractList',
          options: {
            show: true,
            value: 'contractUuid',
            region: 'companyName',
            vue: 'contractName',
            labelShowInDetail: false,
            useTemplate: ['productName' , 'start' , 'end' , 'currentPrice'],
          },
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'CONTRACT_LINKED_CHECKBOX_MODAL',
          controlName: ['onlyNotLinked'],
          placeholder: 'CONTRACT_LINKED_CHECKBOX_MODAL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            labelPosition: 'left',
            inputOptions: false,
          }
        },
        {
          type: 'typeAhead',
          label: 'CONTRACT_LINK_MODAL_SUBSCRIPTIONS',
          controlName: ['subscriptionName', 'subscriptionUuid'],
          placeholder: 'CONTRACT_LINK_MODAL_SUBSCRIPTIONS_PLACEHOLDER',
          data: 'subscriptionList',
          options: {
            show: true,
            value: 'subscriptionUuid',
            vue: 'subscriptionName',
            optionsValue: 'isBillingLinked',
            labelShowInDetail: false
          },
          presentation: 'edit'
        },

      ]
    }
  };
  getLinkContractAnomalies(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'CONTRACT_LINK_MODAL_BILLING_START',
          controlName: ['startBilling'],
          placeholder: 'CONTRACT_LINK_MODAL_BILLING_START',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              daysOfWeekDisable: false,
              useCurrent: false,
              defaultDate: null
            }
          },
        },
        {
          type: 'datePicker',
          label: 'CONTRACT_LINK_MODAL_BILLING_END',
          controlName: ['endBilling'],
          placeholder: 'CONTRACT_LINK_MODAL_BILLING_END',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              daysOfWeekDisable: false,
              useCurrent: false,
              defaultDate: null,
              checkboxEndlessMode: true,
              checkboxEndlessModeCheck: true,
              checkboxEndlessModeText: 'DATE_PICKER_CHECKBOX_OPTIONS',
            }
          },
        },
        {
          type: 'typeAhead',
          label: 'CONTRACT_LINK_MODAL_COMPANY',
          controlName: ['companyName', 'companyUuid'],
          placeholder: 'CONTRACT_LINK_MODAL_COMPANY_PLACEHOLDER',
          data: 'companyList',
          options: {
            show: true,
            value: 'companyUuid',
            vue: 'companyName',
            labelShowInDetail: false,
            typeaheadOptionsLimit: 25,
            typeaheadAsync: true,
            typeaheadDebounce: 600,
            typeaheadAction: new LoadMyCompaniesLinkContractAction()
          },
          presentation: 'edit'
        },
        {
          type: 'typeAhead',
          label: 'CONTRACT_LINK_MODAL_CONTRACT',
          controlName: ['contractName', 'contractUuid'],
          placeholder: 'CONTRACT_LINK_MODAL_CONTRACT_PLACEHOLDER',
          data: 'contractList',
          options: {
            show: true,
            value: 'contractUuid',
            vue: 'contractName',
            region: 'companyName',
            labelShowInDetail: false,
            useTemplate: ['productName' , 'start' , 'end', 'currentPrice'],
            // typeaheadOptionsLimit: 25,
            // typeaheadAsync: true,
            // typeaheadDebounce: 600,
            // typeaheadAction: new LoadLinkContractAction()
          },
          presentation: 'edit'
        },

      ]
    }
  };

  getLinkContractOptionnelCompany(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'CONTRACT_LINK_MODAL_BILLING_START',
          controlName: ['startBilling'],
          placeholder: 'CONTRACT_LINK_MODAL_BILLING_START',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              daysOfWeekDisable: false,
              useCurrent: false,
              defaultDate: null
            }
          },
        },
        {
          type: 'datePicker',
          label: 'CONTRACT_LINK_MODAL_BILLING_END',
          controlName: ['endBilling'],
          placeholder: 'CONTRACT_LINK_MODAL_BILLING_END',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              daysOfWeekDisable: false,
              useCurrent: false,
              defaultDate: null,
              checkboxEndlessMode: true,
              checkboxEndlessModeCheck: true,
              checkboxEndlessModeText: 'DATE_PICKER_CHECKBOX_OPTIONS',
            }
          },
        },
        {
          type: 'typeAhead',
          label: 'CONTRACT_LINK_MODAL_COMPANY',
          controlName: ['companyName', 'companyUuid'],
          placeholder: 'CONTRACT_LINK_MODAL_COMPANY_PLACEHOLDER',
          data: 'companyList',
          options: {
            show: true,
            value: 'companyUuid',
            vue: 'companyName',
            labelShowInDetail: false,
            typeaheadOptionsLimit: 25,
            typeaheadAsync: true,
            typeaheadDebounce: 600,
            typeaheadAction: new LoadMyCompaniesLinkContractAction(),
            checkboxEndlessMode: true,
            checkboxEndlessModeCheck: true,
            checkboxEndlessModeText: 'KEEP_THE_ACTUAL_LINKED_COMPANY_CHECKBOX_OPTIONS',
          },
          presentation: 'edit'
        },
        {
          type: 'typeAhead',
          label: 'CONTRACT_LINK_MODAL_CONTRACT',
          controlName: ['contractName', 'contractUuid'],
          placeholder: 'CONTRACT_LINK_MODAL_CONTRACT_PLACEHOLDER',
          data: 'contractList',
          options: {
            show: true,
            value: 'contractUuid',
            vue: 'contractName',
            region: 'companyName',
            labelShowInDetail: false,
            useTemplate: ['productName' , 'start' , 'end', 'currentPrice'],
            // typeaheadOptionsLimit: 25,
            // typeaheadAsync: true,
            // typeaheadDebounce: 600,
            // typeaheadAction: new LoadLinkContractAction()
          },
          presentation: 'edit'
        },

      ]
    }
  };
  getDuplicationContract(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_SUFFIX_LABEL2',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_SUFFIX_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            inputExtraLabels : '',
          }
        },
        {
          type: 'datePicker',
          label: 'CONTRACT_LINK_MODAL_CONTRACT_START',
          controlName: ['start'],
          placeholder: 'CONTRACT_LINK_MODAL_CONTRACT_START',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
        },
        {
          type: 'datePicker',
          label: 'CONTRACT_LINK_MODAL_CONTRACT_END',
          controlName: ['end'],
          placeholder: 'CONTRACT_LINK_MODAL_CONTRACT_END',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              checkboxEndlessMode: true,
              checkboxEndlessModeCheck: true,
              checkboxEndlessModeText: 'DATE_PICKER_CHECKBOX_OPTIONS',
            }
          },
        },
        {
          type: 'typeAhead',
          label: 'CONTRACT_LINK_MODAL_COMPANY',
          controlName: ['companyName', 'companyUuid'],
          placeholder: 'CONTRACT_LINK_MODAL_COMPANY_PLACEHOLDER',
          data: 'companyList',
          options: {
            show: true,
            value: 'companyUuid',
            vue: 'companyName',
            labelShowInDetail: false
          },
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'CONTRACT_DUPLICATE_MODAL_CONTRACT',
          controlName: ['isRuleDuplicate'],
          placeholder: 'CONTRACT_FORM_IS_INDEX',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: false,
            labelPosition: 'left'
          }
        },
        ]
    }
  };
  closeSubscription(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'END_BILLING_START_DATE',
          controlName: ['startBilling'],
          placeholder: 'END_BILLING_START_DATE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
        },
        {
          type: 'datePicker',
          label: 'GENERIC_PUBLICATION_ENDDATE',
          controlName: ['endBilling'],
          placeholder: 'GENERIC_PUBLICATION_ENDDATE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              numberDelayDays: 0,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              checkboxEndlessMode: true,
              checkboxEndlessModeCheck: false,
              checkboxEndlessModeText: 'DATE_PICKER_CHECKBOX_OPTIONS',
            }
          },
        },
        {
          type: 'textarea',
          label: 'GENERIC_REASON',
          controlName: ['comment'],
          placeholder: 'GENERIC_REASON',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            rows: 5
          }
        }

      ]
    }
  };
  closeSubscriptionDetail(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'END_BILLING_START_DATE',
          controlName: ['startBilling'],
          placeholder: 'END_BILLING_START_DATE',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
        },
        {
          type: 'datePicker',
          label: 'GENERIC_PUBLICATION_ENDDATE',
          controlName: ['endBilling'],
          placeholder: 'GENERIC_PUBLICATION_ENDDATE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              numberDelayDays: 0,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              checkboxEndlessMode: true,
              checkboxEndlessModeCheck: false,
              checkboxEndlessModeText: 'DATE_PICKER_CHECKBOX_OPTIONS',
            }
          },
        },
        {
          type: 'textarea',
          label: 'GENERIC_REASON',
          controlName: ['comment'],
          placeholder: 'GENERIC_REASON',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            rows: 5
          }
        }

      ]
    }
  };

  getInvoicesilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigCompanyInvoicesFilter()
      ]
    }
  }
  getInvoicesSiteFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigSiteInvoicesFilter()
      ]
    }
  }
  getInvoicesContractFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigContractInvoicesFilter()
      ]
    }
  }
  getConfigCompanyInvoicesFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'GENERIC_COVERS_START',
          controlName: ['coverStart'],
          placeholder: 'GENERIC_COVERS_START',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_COVERS_END',
          controlName: ['coverEnd'],
          placeholder: 'GENERIC_COVERS_END',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_PURCHASE_ORDER',
          controlName: ['purchaseOrder'],
          placeholder: 'CONTRACT_FORM_RULES_PURCHASE_ORDER',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_INVOICE_NUMBER',
          controlName: ['number'],
          placeholder: 'GENERIC_INVOICE_NUMBER',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'checkBox',
          label: 'GENERIC_INVOICE_IS_ADJUSTMENT',
          controlName: ['isAdjustment'],
          placeholder: 'GENERIC_INVOICE_IS_ADJUSTMENT',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left'
          }
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['countryCode', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'code',
            vue: 'name'
          },
          presentation: 'filter',
        },
        {
          type: 'select',
          label: 'CONTRACT_FORM_SPLIT',
          controlName: ['split', 'id'],
          placeholder: 'CONTRACT_FORM_SPLIT',
          data: 'split',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_CODE',
          controlName: ['code'],
          placeholder: 'GENERIC_CODE',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        // {
        //   type: 'select',
        //   label: 'GENERIC_OFFICE',
        //   controlName: ['officeID', 'id'],
        //   placeholder: 'GENERIC_OFFICE',
        //   data: 'office',
        //   options: {value: 'id', vue: 'name'},
        //   presentation: 'filter'
        // },
        // {
        //   type: 'input',
        //   label: 'INVOICES_LOGISTIC_JOURNAL',
        //   controlName: ['logisticJournal'],
        //   placeholder: 'INVOICES_LOGISTIC_JOURNAL',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_CODE',
        //   controlName: ['logisticsIdentifier'],
        //   placeholder: 'GENERIC_CODE',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_COUNT',
        //   controlName: ['count'],
        //   placeholder: 'GENERIC_COUNT',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_UNIT_PRICE',
        //   controlName: ['unitPrice'],
        //   placeholder: 'GENERIC_UNIT_PRICE',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        {
          type: 'input',
          label: 'GENERIC_TOTAL',
          controlName: ['total'],
          placeholder: 'GENERIC_TOTAL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_CREATED',
          controlName: ['date'],
          placeholder: 'GENERIC_CREATED',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
          presentation: 'filter'
        },
      ]
    }
  }
  getConfigSiteInvoicesFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_COMPANY_NAME',
          controlName: ['companyName'],
          placeholder: 'GENERIC_COMPANY_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CONTRACT_NAME',
          controlName: ['contractName'],
          placeholder: 'GENERIC_CONTRACT_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_COVERS_START',
          controlName: ['coverStart'],
          placeholder: 'GENERIC_COVERS_START',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_COVERS_END',
          controlName: ['coverEnd'],
          placeholder: 'GENERIC_COVERS_END',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_PURCHASE_ORDER',
          controlName: ['purchaseOrder'],
          placeholder: 'CONTRACT_FORM_RULES_PURCHASE_ORDER',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_INVOICE_NUMBER',
          controlName: ['number'],
          placeholder: 'GENERIC_INVOICE_NUMBER',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'checkBox',
          label: 'GENERIC_INVOICE_IS_ADJUSTMENT',
          controlName: ['isAdjustment'],
          placeholder: 'GENERIC_INVOICE_IS_ADJUSTMENT',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left'
          }
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['countryCode', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'code',
            vue: 'name'
          },
          presentation: 'filter',
        },
        {
          type: 'select',
          label: 'CONTRACT_FORM_SPLIT',
          controlName: ['split', 'id'],
          placeholder: 'CONTRACT_FORM_SPLIT',
          data: 'split',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_CODE',
          controlName: ['code'],
          placeholder: 'GENERIC_CODE',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        // {
        //   type: 'select',
        //   label: 'GENERIC_OFFICE',
        //   controlName: ['office', 'id'],
        //   placeholder: 'GENERIC_OFFICE',
        //   data: 'office',
        //   options: {value: 'id', vue: 'name'},
        //   presentation: 'filter'
        // },
        // {
        //   type: 'input',
        //   label: 'INVOICES_LOGISTIC_JOURNAL',
        //   controlName: ['logisticJournal'],
        //   placeholder: 'INVOICES_LOGISTIC_JOURNAL',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_CODE',
        //   controlName: ['Code'],
        //   placeholder: 'GENERIC_CODE',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_COUNT',
        //   controlName: ['count'],
        //   placeholder: 'GENERIC_COUNT',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_UNIT_PRICE',
        //   controlName: ['unitPrice'],
        //   placeholder: 'GENERIC_UNIT_PRICE',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        {
          type: 'input',
          label: 'GENERIC_TOTAL',
          controlName: ['total'],
          placeholder: 'GENERIC_TOTAL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_CREATED',
          controlName: ['date'],
          placeholder: 'GENERIC_CREATED',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
      ]
    }
  }
  getConfigContractInvoicesFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_COMPANY_NAME',
          controlName: ['companyName'],
          placeholder: 'GENERIC_COMPANY_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_COVERS_START',
          controlName: ['coverStart'],
          placeholder: 'GENERIC_COVERS_START',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              daysOfWeekDisable: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'datePicker',
          label: 'GENERIC_COVERS_END',
          controlName: ['coverEnd'],
          placeholder: 'GENERIC_COVERS_END',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              daysOfWeekDisable: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'CONTRACT_FORM_RULES_PURCHASE_ORDER',
          controlName: ['purchaseOrder'],
          placeholder: 'CONTRACT_FORM_RULES_PURCHASE_ORDER',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_INVOICE_NUMBER',
          controlName: ['number'],
          placeholder: 'GENERIC_INVOICE_NUMBER',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'checkBox',
          label: 'GENERIC_INVOICE_IS_ADJUSTMENT',
          controlName: ['isAdjustment'],
          placeholder: 'GENERIC_INVOICE_IS_ADJUSTMENT',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left'
          }
        },
        {
          type: 'select',
          label: 'GENERIC_COUNTRY',
          controlName: ['countryCode', 'code'],
          placeholder: 'GENERIC_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'code',
            vue: 'name'
          },
          presentation: 'filter',
        },
        {
          type: 'select',
          label: 'CONTRACT_FORM_SPLIT',
          controlName: ['split', 'id'],
          placeholder: 'CONTRACT_FORM_SPLIT',
          data: 'split',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: false
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_CODE',
          controlName: ['code'],
          placeholder: 'GENERIC_CODE',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        // {
        //   type: 'select',
        //   label: 'GENERIC_OFFICE',
        //   controlName: ['office', 'id'],
        //   placeholder: 'GENERIC_OFFICE',
        //   data: 'office',
        //   options: {value: 'id', vue: 'name'},
        //   presentation: 'filter'
        // },
        // {
        //   type: 'input',
        //   label: 'INVOICES_LOGISTIC_JOURNAL',
        //   controlName: ['logisticJournal'],
        //   placeholder: 'INVOICES_LOGISTIC_JOURNAL',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_CODE',
        //   controlName: ['logisticsIdentifier'],
        //   placeholder: 'GENERIC_CODE',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_COUNT',
        //   controlName: ['count'],
        //   placeholder: 'GENERIC_COUNT',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        // {
        //   type: 'input',
        //   label: 'GENERIC_UNIT_PRICE',
        //   controlName: ['unitPrice'],
        //   placeholder: 'GENERIC_UNIT_PRICE',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        {
          type: 'input',
          label: 'GENERIC_TOTAL',
          controlName: ['total'],
          placeholder: 'GENERIC_TOTAL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'datePicker',
          label: 'GENERIC_CREATED',
          controlName: ['date'],
          placeholder: 'GENERIC_CREATED',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
            }
          },
          presentation: 'filter'
        },
      ]
    }
  }
  getReturnPlayers(): GroupConfig {
    return {
      'config': [
        {
          type: 'textarea',
          label: 'GENERIC_COMMENT',
          controlName: ['comment'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            rows: 5
          }
        },
        {
          type: 'checkBox',
          label: 'REMOVE_PLAYER_IS_LOST_OR_SOLD',
          controlName: ['playerLost'],
          placeholder: 'REMOVE_PLAYER_IS_LOST_OR_SOLD',
          presentation: 'filter',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left',
          }
        },
        // {
        //   type: 'textarea',
        //   label: 'REASON_REMOVE',
        //   controlName: ['reason'],
        //   placeholder: 'REASON_REMOVE',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //     rows: 5,
        //     toggle: false,
        //   }
        // }

      ]
    }
  };
  getConfigRemovePlayerLostOrSold(): GroupConfig {
    return {
      'config': [
        {
          type: 'textarea',
          label: 'REASON_REMOVE',
          controlName: [ 'reason'],
          placeholder: 'REASON_REMOVE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            rows: 5
          }
        }
      ]
    }
  }
  getConfigSFProject(): GroupConfig {
    return {
      'config': [
        // {
        //   type: 'input',
        //   label: 'GENERIC_PROJECT_NAME',
        //   controlName: ['name'],
        //   placeholder: 'GENERIC_PROJECT_NAME',
        //   presentation: 'filter',
        //   options: {
        //     show: true
        //   }
        // },
        {
          type: 'input',
          label: 'GENERIC_SF_IDENTIFIER',
          controlName: ['salesforceProjectId'],
          placeholder: 'GENERIC_SF_IDENTIFIER_PLACEHOLDER',
          presentation: 'edit',
          options: {
            show: true
          }
        }
      ]
    }
  }
  getConfigGlobalLanguageTexts(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_LOC',
          controlName: ['loc'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_LOC',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_LOC_DAY',
          controlName: ['locDay'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_LOC_DAY',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_LOC_DAY_MON',
          controlName: ['locDayMon'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_LOC_DAY_MON',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        }
      ]
    }
  }
  getConfigReplacementLanguageTexts(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_RECURRENCE',
          controlName: ['recurrence'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_RECURRENCE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_PRODUCT',
          controlName: ['product'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_PRODUCT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_PRODUCT_LOCATION',
          controlName: ['productLoc'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_PRODUCT_LOCATION',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_SERVICE',
          controlName: ['service'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_SERVICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        // {
        //   type: 'input',
        //   label: 'LANGUAGE_TEXTS_LABEL_SERVICE2',
        //   controlName: ['service2'],
        //   placeholder: 'LANGUAGE_TEXTS_LABEL_SERVICE2',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true
        //   }
        // }
      ]
    }
  }
  getLanguageTextsConfigs(): GroupConfigs {
    return {
      'groupConfigs': [this.getConfigFeeLanguageTextsFull()]
    }
  }
  getConfigFeeLanguageTextsFull(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_4G_ROUTER_MANAGEMENT',
          controlName: ['routerManagementLicense'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_4G_ROUTER_MANAGEMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_AUDIO_PLAYER_RENTAL',
          controlName: ['audioPlayerRental'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_AUDIO_PLAYER_RENTAL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_VIDEO_PLAYER_RENTAL',
          controlName: ['videoPlayerRental'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_VIDEO_PLAYER_RENTAL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_BRACKET_RENTAL',
          controlName: ['braketRental'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_BRACKET_RENTAL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_DIV',
          controlName: ['DIV'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_DIV',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_DIV_PERCENT',
          controlName: ['DIVPercent'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_DIV_PERCENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_MATERIAL_LOCATION',
          controlName: ['materialLocation'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_MATERIAL_LOCATION',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_MAINTENANCE',
          controlName: ['maint'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_MAINTENANCE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        // {
        //   type: 'input',
        //   label: 'LANGUAGE_TEXTS_LABEL_VIDEO_MAINTENANCE',
        //   controlName: ['maintVideo'],
        //   placeholder: 'LANGUAGE_TEXTS_LABEL_VIDEO_MAINTENANCE',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true
        //   }
        // },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_MUSIC_SERVICE',
          controlName: ['musicService'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_MUSIC_SERVICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_SOFTWARE_SERVICE',
          controlName: ['softwareService'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_SOFTWARE_SERVICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_MONITOR_RENTAL',
          controlName: ['monitorRental'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_MONITOR_RENTAL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_PROJECT_MANAGEMENT',
          controlName: ['projectManagement'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_PROJECT_MANAGEMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_ONLINE_MAINTENANCE',
          controlName: ['onlineMaintenance'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_ONLINE_MAINTENANCE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_SETUP',
          controlName: ['setup'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_SETUP',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        // {
        //   type: 'input',
        //   label: 'LANGUAGE_TEXTS_LABEL_VIDEO_SETUP',
        //   controlName: ['setupVideo'],
        //   placeholder: 'LANGUAGE_TEXTS_LABEL_VIDEO_SETUP',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true
        //   }
        // },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_PRODUCTION',
          controlName: ['prod'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_PRODUCTION',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        // {
        //   type: 'input',
        //   label: 'LANGUAGE_TEXTS_LABEL_VIDEO_PRODUCTION',
        //   controlName: ['prodVideo'],
        //   placeholder: 'LANGUAGE_TEXTS_LABEL_VIDEO_PRODUCTION',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true
        //   }
        // },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_REMOTE_MANAGEMENT',
          controlName: ['remoteManagement'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_REMOTE_MANAGEMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_SERVICE_SIM_DATA',
          controlName: ['SIMDataService'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_SERVICE_SIM_DATA',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_SLL_CERTIFICATE_RENEW',
          controlName: ['SSLCertificateRenewal'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_SLL_CERTIFICATE_RENEW',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_WIDGET',
          controlName: ['widgetService'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_WIDGET',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        }
      ]
    }
  }
  getConfigFeeLanguageTexts(): GroupConfig {
    return {
      'config': [

        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_MATERIAL_LOCATION',
          controlName: ['materialLocation'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_MATERIAL_LOCATION',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_MUSIC_SERVICE',
          controlName: ['musicService'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_MUSIC_SERVICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_SOFTWARE_SERVICE',
          controlName: ['softwareService'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_SOFTWARE_SERVICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_PROJECT_MANAGEMENT',
          controlName: ['projectManagement'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_PROJECT_MANAGEMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_SETUP',
          controlName: ['setup'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_SETUP',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_PRODUCTION',
          controlName: ['prod'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_PRODUCTION',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_MAINTENANCE',
          controlName: ['maint'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_MAINTENANCE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_DIV',
          controlName: ['DIV'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_DIV',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'LANGUAGE_TEXTS_LABEL_DIV_PERCENT',
          controlName: ['DIVPercent'],
          placeholder: 'LANGUAGE_TEXTS_LABEL_DIV_PERCENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        // {
        //   type: 'input',
        //   label: 'LANGUAGE_TEXTS_LABEL_VIDEO_MAINTENANCE',
        //   controlName: ['maintVideo'],
        //   placeholder: 'LANGUAGE_TEXTS_LABEL_VIDEO_MAINTENANCE',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true
        //   }
        // },

      ]
    }
  }
}

